<template>
  <vs-prompt buttons-hidden title="Add Company" :active="showAddNewCompany && !!availableCompanies.length" @close="close">
    <div id="add-company-loading" class="p-2 vs-con-loading__container">
      <div style="overflow-y: scroll; max-height: 500px;">
        <vs-row vs-w="12" vs-type="flex" vs-align="center" v-for="company in availableCompanies" :key="company.company_id">
          <vs-col vs-w="10" vs-type="flex" vs-align="center">
            <div>{{ company.name }}</div>
          </vs-col>
          <vs-col vs-w="2" vs-type="flex" vs-justify="flex-end" vs-align="center" class="pr-4">
            <div>
              <vs-icon size="20px" color="primary" type="flat" class="float-left" style="cursor:pointer;" icon="add_circle" @click="addCompany(company)" />
            </div>
          </vs-col>
          <vs-divider color="lightgray" class="mt-5 mb-4 pr-4"/>
        </vs-row>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import api from "@/http/api";

export default {
  props: [
    'trustedPartnerId',
    'showAddNewCompany',
    'companies'
  ],
  data() {
    return {
      availableCompanies: [],
      loading: false
    }
  },
  mounted() {
    this.fetch();
  },
  updated() {
    this.fetch();
  },
  methods: {
    async fetch() {
      const res = await api.fetchAllCompanies();
      this.availableCompanies = res.companies.filter(c => !this.companies.filter(sc => sc.company_id === c.company_id).length);
    },
    close() {
      this.$emit('update:showAddNewCompany', false);
    },
    async addCompany(company) {
      if(this.loading) return;
      this.showSpinnerOverCard();

      const success = await api.addTrustedPartnerCompany(this.trustedPartnerId, company.company_id);
      if (success) {
        this.$emit('update:companies', this.companies.push(company));
        this.availableCompanies = this.availableCompanies.filter(c => c.company_id !== company.company_id);
      }

      this.$vs.notify({
        title: success ? 'Success' : 'Failed',
        text:  success ? 'Added Successfully!' : 'Unable to be added!',
        color: success ? 'success' : 'danger',
        icon:  success ? 'check_circle_outline' : 'error'
      });
      this.hideSpinnerOverCard()
    },
    showSpinnerOverCard() {
      this.loading = true;
      this.$vs.loading({
        container: `#add-company-loading`,
        scale: 0.6
      });
    },
    hideSpinnerOverCard() {
      this.loading = false;
      this.$vs.loading.close(`#add-company-loading > .con-vs-loading`)
    },
  }
}
</script>
